module.exports = __webpack_public_path__ + "3595072360a43849c708bb935945bbf6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/day_1.jpg
// module id = 1657
// module chunks = 5